import { useState } from 'react';
import { savePropertySnapshot } from '../lib/snapshot';

export function PropertySnapshot({ propertyId, propertyName }: { propertyId: string; propertyName: string }) {
  const [busy, setBusy] = useState(false), [message, setMessage] = useState('');
  const [omissions, setOmissions] = useState<string[]>([]);
  return <section className="panel">
    <h2>Save your property record</h2>
    <p>Download a dated ZIP with accessible property records, participant references, project records, history, and document files. Keep a private copy for your home or property's operating record.</p>
    <p className="fine">Export limit: 100 MB of documents. This is a portable export, not a locked or certified backup. Any missing records or files are listed in the manifest.</p>
    <button className="button secondary" disabled={busy} onClick={async () => {
      setBusy(true); setOmissions([]);
      try {
        const result = await savePropertySnapshot(propertyId, propertyName, setMessage);
        setOmissions(result.omissions);
        setMessage(result.omissions.length ? `Partial export prepared with ${result.documents} document files. Review omissions below and in manifest.json.` : `Export prepared with ${result.documents} document files. Save the ZIP in a secure location.`);
      } catch (error) { setMessage(error instanceof Error ? error.message : 'Export failed.'); }
      finally { setBusy(false); }
    }}>{busy ? 'Preparing property export…' : 'Save property record'}</button>
    <p role="status">{message}</p>
    {omissions.length > 0 && <details open><summary>Export omissions</summary><ul>{omissions.map((item, index) => <li key={index}>{item}</li>)}</ul></details>}
  </section>;
}
